import { render, staticRenderFns } from "./InstructionsListModel.vue?vue&type=template&id=d44646ce&scoped=true&"
import script from "./InstructionsListModel.vue?vue&type=script&lang=js&"
export * from "./InstructionsListModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44646ce",
  null
  
)

export default component.exports